import { MapContainer, TileLayer, useMap, LayersControl } from 'react-leaflet'
import "leaflet.vectorgrid";
import ActiveLayers from './ActiveLayers';
import { getBaseLayerInfo, getVectorLayerInfo } from "../../utils/layer";
import { ProtobufLayer } from './ProtobufLayer';
import Logo from '../logos/Logo';
import { Box, Grid } from '@mui/material';

var core = require("@react-leaflet/core");
const logoRss = require('../../ressources/logos/logoRssLight.png')
const logoNwa = require('../../ressources/logos/logoNWALight.png')

// GEOSERVER_PREFIX + '/geoserver/gwc/service/tms/1.0.0/arnsberg:Final_Waldtyp_raster' +
//                     '@EPSG:900913' + '@png/{z}/{x}/{-y}.png',

export default function Map(props) {
    // const outerBounds = [[51.2, 7.5], [51.6, 8.5]]
    return (
        <Box
            position="fixed"
            sx={{ width: "100%" }}
        >
            <MapContainer
                // bounds={outerBounds} 
                center={[51.407, 8.0]}
                zoom={12}
                zoomControl={false}
                scrollWheelZoom={true}
                className="map-container"
                maxZoom={16}
                minZoom={12}
                maxBounds={[[51.244417, 7.715743], [51.604920, 8.379042]]}
            >
                <ActiveLayers {...props} ></ActiveLayers>



                <LayersControl position="topright">
                    <LayersControl.BaseLayer name="Satellit" checked >
                        <TileLayer
                            // zIndex={1}
                            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                            url="https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}"
                        />
                    </LayersControl.BaseLayer>

                    <LayersControl.BaseLayer name="Karte">
                        <TileLayer
                            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        />
                    </LayersControl.BaseLayer>
                    <LayersControl.BaseLayer name={getBaseLayerInfo("s2_july_2016", "", false)[0].label}>
                        <TileLayer
                            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                            url={getBaseLayerInfo("s2_july_2016", "", false)[0].url}
                        />
                    </LayersControl.BaseLayer>
                    {/* <LayersControl.BaseLayer name={getBaseLayerInfo("s2_july_2020", "", false)[0].label}>
                        <TileLayer
                            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                            url={getBaseLayerInfo("s2_july_2020", "", false)[0].url}
                        />
                    </LayersControl.BaseLayer>
                    <LayersControl.BaseLayer name={getBaseLayerInfo("s2_july_2021", "", false)[0].label}>
                        <TileLayer
                            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                            url={getBaseLayerInfo("s2_july_2021", "", false)[0].url}
                        />
                    </LayersControl.BaseLayer> */}
                    <LayersControl.BaseLayer name={getBaseLayerInfo("s2_july_2022", "", false)[0].label}>
                        <TileLayer
                            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                            url={getBaseLayerInfo("s2_july_2022", "", false)[0].url}
                        />
                    </LayersControl.BaseLayer>
                    <LayersControl.BaseLayer name={getBaseLayerInfo("s2_july_2023", "", false)[0].label}>
                        <TileLayer
                            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                            url={getBaseLayerInfo("s2_july_2023", "", false)[0].url}
                        />
                    </LayersControl.BaseLayer>
                    <LayersControl.BaseLayer name={getBaseLayerInfo("s2_june_2024", "", false)[0].label}>
                        <TileLayer
                            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                            url={getBaseLayerInfo("s2_june_2024", "", false)[0].url}
                        />
                    </LayersControl.BaseLayer>
                    <LayersControl.BaseLayer name={getBaseLayerInfo("s2_june_2025", "", false)[0].label}>
                        <TileLayer
                            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                            url={getBaseLayerInfo("s2_june_2025", "", false)[0].url}
                        />
                    </LayersControl.BaseLayer>

                    <Box sx={{ zIndex: 500, position: "fixed", right: 10, bottom: 25 }}>

                        <Grid container spacing={2}>
                            <Grid item>
                                <Logo width='60px' imageSource={logoRss} urlClick="https://www.remote-sensing-solutions.com/de/" />

                            </Grid>
                            <Grid item>
                                <Logo width='140px' imageSource={logoNwa} urlClick="https://naturwald-akademie.org/" />

                            </Grid>

                        </Grid>

                    </Box>


                </LayersControl>
            </MapContainer>
        </Box>
    )
}




